import { useEffect, useState } from 'react';
import { useSearchParams  } from "react-router-dom";
import { SearchMode } from '@common/types';

interface UseSearchOptions {
  searchMode?: SearchMode;
}

export const useSearch = (options?: UseSearchOptions) => {
  const { searchMode = SearchMode.General } = options || {};

  const [searchParams] = useSearchParams();

  const [displayPhrase, setDisplayPhrase] = useState(searchParams.get('searchTerm') ?? '');
  const [searchPhrase, setSearchPhrase] = useState('');

  const handleChangeSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget.value;
    if (inputValue.trim() === '') {
      setDisplayPhrase('');
    } else {
      setDisplayPhrase(e.currentTarget.value);
    }
  };

  const handleClearSearch = () => {
    setDisplayPhrase('');
    setSearchPhrase('');
  };

  const getSearchError = () => {
    if (displayPhrase === '') return undefined;

    if (searchMode === SearchMode.ProductId) {
      if (!/^\d+$/.test(displayPhrase)) {
        return 'Please enter only numbers';
      }
    } else {
      if (displayPhrase.length < 3) {
        return 'Please enter at least 3 characters';
      }
    }

    return undefined;
  };

  const searchError = getSearchError();

  useEffect(() => {
    const delay = setTimeout(() => {
      if (displayPhrase.length === 0 || getSearchError() === undefined) {
        setSearchPhrase(encodeURIComponent(displayPhrase));
      }
    }, 500);

    return () => clearTimeout(delay);
  }, [displayPhrase, searchMode]);

  return { searchPhrase, displayPhrase, searchError, handleChangeSearch, handleClearSearch };
};
